import { Box, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import RepartionEspecesChequesRetrait from "./rep-especes-cheques-retrait";
import { fedVerseTypes } from "../asset/variables";
import moment from "moment";

export default function Step3(props) {
    const [repespeces, setRepEspeces] = useState(props.fedRepartition.especes)
    const [repCheque, setRepCheques] = useState(props.fedRepartition.cheques)
    const [retrait, setRetrait] = useState(props.fedRepartition.retrait)
    const [virement, setVirement] = useState(props.fedRepartition.virement)

    const dispoMoney = [...new Set(props.dons?.map(don=>don.repartition.especes.map(es=>es.montant)).flat())].map(money=>{
        const count = props.dons.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)
        return {montant:money, count}
    })
    const dispoCheques = props.dons?.map(don=>don.repartition.cheques).flat().filter(cheque=> cheque)

    const ttEspeces = useMemo(()=>repespeces.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[repespeces])
    const ttRetrait = useMemo(()=>retrait.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[retrait])
    const ttCheques = useMemo(()=>repCheque.reduce((tt,ch)=>tt+ch.montant,0),[repCheque])
    const total = useMemo(()=>ttEspeces+ttCheques+ttRetrait+virement.montant,[ttEspeces, ttCheques, ttRetrait, virement])

    useEffect(()=>props.setFedRepartition({especes:repespeces, cheques:repCheque, retrait, virement}),[repespeces, repCheque, retrait, virement])

    return(
        <Box>
            <Typography variant="h6" align="center">Versement FEAM</Typography>
            <Typography variant="subtitle1" align="center" color='red'>Le versement FEAM doit être d'une valeur supérieure ou égale à la recette fédérale qui s'élève à {props.fed_part.toFixed(2)}€</Typography>
            <Typography variant="subtitle1" marginTop={2} marginBottom={1}>{fedVerseTypes.find(fvt=>fvt.value===props.fedVerseType)?.label}</Typography>
            {props.fedVerseType!=='virement'?<RepartionEspecesChequesRetrait  { ...{repespeces, setRepEspeces, dispoMoney, repCheque, setRepCheques, dispoCheques, retrait, setRetrait, eglise: props.eglise}}/>
            :<Stack direction='row' spacing={2} alignItems='center' flexWrap='wrap' marginBottom={3}>
                <Typography>Date:</Typography>
                <TextField type="date" size="small" required value={moment(virement.date).format('yyyy-MM-DD')??''} onChange={e=>setVirement(old=>{return({...old, date:e.target.value})})}/>
                <TextField type="number" size="small" label='montant' value={virement.montant??''} onChange={e=>{if(Number(e.target.value)>=0){setVirement(old=>{return({...old,montant:Number(Number(e.target.value).toFixed(2))})})}}}/>
                <TextField size="small" label='Référence' value={virement.ref??''} onChange={e=>setVirement(old=>{return({...old, ref:e.target.value})})}/>
            </Stack>}
            {props.fedVerseType==='banque'&&<Stack direction='row' spacing={2} alignItems='center' marginTop={2}>
                <Typography>Banque fédération:</Typography>
                <TextField select required size="small" sx={{width:'30%', minWidth:'250px'}} value={props.fedBanque} onChange={e=>props.setFedBanque(e.target.value)}>
                    {props.banqueComptes.map(cpt=><MenuItem key={cpt._id} value={cpt.num}>{cpt.banque}</MenuItem>)}
                </TextField>
            </Stack>}
            {props.fedVerseType!=='virement'&&<Stack direction='row' spacing={5} alignItems='center' justifyContent='center' marginTop={3}>
                {ttEspeces+ttRetrait>0&&<Typography variant="h6">Montant total espèce: {(ttEspeces+ttRetrait).toFixed(2)}€</Typography>}
                {dispoCheques.length>0&&<Typography variant="h6">Montant total chèque: {ttCheques.toFixed(2)}€</Typography>}
            </Stack>}
            <Typography variant="h6" fontWeight='bold' align="center">Montant total du versement: {total.toFixed(2)}€</Typography>
        </Box>
    )
}